import { Controller } from "@hotwired/stimulus"
import "chartkick/chart.js"

export default class extends Controller {
  connect() {}
}